import type { Connector } from 'wagmi'

export const WAGMI_CONNECTOR_WC = 'walletConnect'
export const WAGMI_CONNECTOR_MONE = 'mOneWalletConnect'

export function isWalletConnectLike(connector: Connector | undefined | null): boolean {
  if (!connector) return false
  return (
    connector.type === 'walletConnect' ||
    connector.id === WAGMI_CONNECTOR_WC ||
    connector.id === WAGMI_CONNECTOR_MONE
  )
}

export function isInjectedLike(connector: Connector | undefined | null): boolean {
  if (!connector) return false
  return connector.type === 'injected' || connector.id === 'injected' || connector.id === 'io.metamask'
}
